import { render, staticRenderFns } from "./UpdateOS.vue?vue&type=template&id=1331ae22&scoped=true"
import script from "./UpdateOS.vue?vue&type=script&lang=js"
export * from "./UpdateOS.vue?vue&type=script&lang=js"
import style0 from "./UpdateOS.vue?vue&type=style&index=0&id=1331ae22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1331ae22",
  null
  
)

export default component.exports